var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { GRID_UNIT } from '../../utilities/grid';
import { Text } from '../Text';
export var AccordionContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  p,\n  * {\n    color: ", ";\n    font-size: 13px;\n    line-height: 20px;\n  }\n"], ["\n  p,\n  * {\n    color: ", ";\n    font-size: 13px;\n    line-height: 20px;\n  }\n"])), function (_a) {
  var color = _a.color,
    theme = _a.theme;
  return color ? color : theme.tokens.text.paragraph.light;
});
export var LinkParagraph = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-top: ", "px;\n  text-align: center;\n"], ["\n  padding-top: ", "px;\n  text-align: center;\n"])), GRID_UNIT * 3);
export var SkeletonContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 224px;\n"], ["\n  height: 224px;\n"])));
export var SkeletonParagraph = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 16px 0;\n"], ["\n  padding: 16px 0;\n"])));
export var Subtitle = styled(Text)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: ", "px 0;\n"], ["\n  margin: ", "px 0;\n"])), GRID_UNIT);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;